import React from "react"
import clsx from "clsx"
import MarkdownView from "react-showdown"
import {Skeleton} from "@chakra-ui/react"


export function PlayCard({title, noTitleBorder, isLoading, className, markdownContent, footer, children}: {
    title?: string,
    noTitleBorder?: boolean,
    isLoading?: boolean,
    className?: string,
    markdownContent?: string,
    footer?: React.ReactNode,
    children?: React.ReactNode,
}) {

    // return <div className={clsx("divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow", className)}>
    //     <div className="px-4 py-5 sm:px-6">
    //         {title &&
    //           <h2
    //             className={clsx("text-base font-medium text-gray-900 pb-2")}>{title}</h2>
    //         }
    //     </div>
    //     <div className="px-4 py-5 sm:p-6">
    //         <Skeleton isLoaded={!isLoading}>
    //             {children}
    //         </Skeleton>
    //     </div>
    //
    //     {footer && <div className="px-4 py-4 sm:px-6">
    //         {footer}
    //     </div>}
    // </div>

    return <div className={clsx("rounded-lg bg-white p-6 flex flex-col justify-between",
        className)}>
        <div>
            {title &&
              <div
                className={clsx("text-base font-medium text-gray-900 pb-2", !noTitleBorder && "border-b mb-4")}>{title}</div>
            }
            <Skeleton isLoaded={!isLoading}>
                {markdownContent &&
                  <MarkdownView
                    markdown={markdownContent}
                    options={{
                        simpleLineBreaks: true,
                        strikethrough: true,
                        openLinksInNewWindow: true
                    }}
                  />}
                {children}
            </Skeleton>
        </div>

        {footer}
    </div>
}